import * as d3 from 'd3'
import Chart from '../chart'

import './TinyConsumptionEvolution.css'

const consumptionEvolutionData = [[{"region":"BRUXELLES / BRUSSEL","year":"2010","mcMembers":156142,"opioid":10990,"oxycodoneOther":63,"opioidFullYear":1120,"opioidRatio":0.07038464986999014,"oxycodoneOtherRatio":0.000403478884605039,"opioidFullYearRatio":0.007172957948534027},{"region":"BRUXELLES / BRUSSEL","year":"2011","mcMembers":159877,"opioid":11760,"oxycodoneOther":128,"opioidFullYear":1223,"opioidRatio":0.07355654659519506,"oxycodoneOtherRatio":0.0008006154731449802,"opioidFullYearRatio":0.007649630653564928},{"region":"BRUXELLES / BRUSSEL","year":"2012","mcMembers":164491,"opioid":11988,"oxycodoneOther":177,"opioidFullYear":1209,"opioidRatio":0.07287936726021485,"oxycodoneOtherRatio":0.0010760467138019709,"opioidFullYearRatio":0.00734994619766431},{"region":"BRUXELLES / BRUSSEL","year":"2013","mcMembers":167925,"opioid":12555,"oxycodoneOther":290,"opioidFullYear":1236,"opioidRatio":0.07476552032157213,"oxycodoneOtherRatio":0.0017269614411195475,"opioidFullYearRatio":0.007360428762840554},{"region":"BRUXELLES / BRUSSEL","year":"2014","mcMembers":167975,"opioid":12752,"oxycodoneOther":356,"opioidFullYear":1256,"opioidRatio":0.07591605893734187,"oxycodoneOtherRatio":0.002119363000446495,"opioidFullYearRatio":0.007477303170114601},{"region":"BRUXELLES / BRUSSEL","year":"2015","mcMembers":167340,"opioid":13008,"oxycodoneOther":399,"opioidFullYear":1304,"opioidRatio":0.07773395482251703,"oxycodoneOtherRatio":0.0023843671566869847,"opioidFullYearRatio":0.007792518226365484},{"region":"BRUXELLES / BRUSSEL","year":"2016","mcMembers":167707,"opioid":13332,"oxycodoneOther":437,"opioidFullYear":1349,"opioidRatio":0.07949578729570024,"oxycodoneOtherRatio":0.002605735002116787,"opioidFullYearRatio":0.008043790658708342},{"region":"BRUXELLES / BRUSSEL","year":"2017","mcMembers":167718,"opioid":12986,"oxycodoneOther":462,"opioidFullYear":1227,"opioidRatio":0.07742758678257551,"oxycodoneOtherRatio":0.0027546238328623046,"opioidFullYearRatio":0.00731585160805638},{"region":"BRUXELLES / BRUSSEL","year":"2018","mcMembers":166868,"opioid":13251,"oxycodoneOther":524,"opioidFullYear":1281,"opioidRatio":0.07941007263226023,"oxycodoneOtherRatio":0.0031402066303904885,"opioidFullYearRatio":0.00767672651437064}],[{"region":"REGION WALLONNE","year":"2010","mcMembers":909782,"opioid":88329,"oxycodoneOther":1425,"opioidFullYear":9804,"opioidRatio":0.09708809363122155,"oxycodoneOtherRatio":0.0015663092916764676,"opioidFullYearRatio":0.010776207926734097},{"region":"REGION WALLONNE","year":"2011","mcMembers":930372,"opioid":95154,"oxycodoneOther":2267,"opioidFullYear":11020,"opioidRatio":0.1022752189446802,"oxycodoneOtherRatio":0.002436659744704269,"opioidFullYearRatio":0.011844724475801078},{"region":"REGION WALLONNE","year":"2012","mcMembers":942210,"opioid":95823,"oxycodoneOther":3147,"opioidFullYear":11320,"opioidRatio":0.10170025790428885,"oxycodoneOtherRatio":0.00334001974082211,"opioidFullYearRatio":0.012014306789356938},{"region":"REGION WALLONNE","year":"2013","mcMembers":946817,"opioid":99052,"oxycodoneOther":4423,"opioidFullYear":11742,"opioidRatio":0.10461578108546847,"oxycodoneOtherRatio":0.004671441260560382,"opioidFullYearRatio":0.012401551725412619},{"region":"REGION WALLONNE","year":"2014","mcMembers":950543,"opioid":104021,"oxycodoneOther":4979,"opioidFullYear":12194,"opioidRatio":0.10943323973770781,"oxycodoneOtherRatio":0.005238058667519512,"opioidFullYearRatio":0.012828456997737082},{"region":"REGION WALLONNE","year":"2015","mcMembers":950273,"opioid":105593,"oxycodoneOther":6306,"opioidFullYear":12401,"opioidRatio":0.11111859434078418,"oxycodoneOtherRatio":0.006635987763516379,"opioidFullYearRatio":0.013049934071577325},{"region":"REGION WALLONNE","year":"2016","mcMembers":949259,"opioid":108071,"oxycodoneOther":6844,"opioidFullYear":12713,"opioidRatio":0.11384774861233868,"oxycodoneOtherRatio":0.007209834196989441,"opioidFullYearRatio":0.013392551453291462},{"region":"REGION WALLONNE","year":"2017","mcMembers":943347,"opioid":105503,"oxycodoneOther":7187,"opioidFullYear":11741,"opioidRatio":0.11183901575984234,"oxycodoneOtherRatio":0.00761861753946321,"opioidFullYearRatio":0.012446109437990474},{"region":"REGION WALLONNE","year":"2018","mcMembers":944066,"opioid":108350,"oxycodoneOther":7553,"opioidFullYear":12707,"opioidRatio":0.11476951823283542,"oxycodoneOtherRatio":0.008000499965044816,"opioidFullYearRatio":0.01345986403492976}],[{"region":"VLAAMS GEWEST","year":"2010","mcMembers":3288688,"opioid":177237,"oxycodoneOther":3760,"opioidFullYear":21391,"opioidRatio":0.0538929202162078,"oxycodoneOtherRatio":0.001143313078042064,"opioidFullYearRatio":0.006504417567127073},{"region":"VLAAMS GEWEST","year":"2011","mcMembers":3302493,"opioid":189331,"oxycodoneOther":4703,"opioidFullYear":24189,"opioidRatio":0.05732972030523607,"oxycodoneOtherRatio":0.0014240756906979061,"opioidFullYearRatio":0.007324466698339709},{"region":"VLAAMS GEWEST","year":"2012","mcMembers":3311580,"opioid":196397,"oxycodoneOther":6153,"opioidFullYear":25360,"opioidRatio":0.05930613181623273,"oxycodoneOtherRatio":0.0018580254742449223,"opioidFullYearRatio":0.0076579759510565955},{"region":"VLAAMS GEWEST","year":"2013","mcMembers":3310692,"opioid":208996,"oxycodoneOther":8780,"opioidFullYear":26918,"opioidRatio":0.06312758782755992,"oxycodoneOtherRatio":0.0026520135367470005,"opioidFullYearRatio":0.008130626467215917},{"region":"VLAAMS GEWEST","year":"2014","mcMembers":3313258,"opioid":225098,"oxycodoneOther":10141,"opioidFullYear":28873,"opioidRatio":0.06793856681248488,"oxycodoneOtherRatio":0.0030607335740229103,"opioidFullYearRatio":0.008714383244528497},{"region":"VLAAMS GEWEST","year":"2015","mcMembers":3319604,"opioid":235704,"oxycodoneOther":11898,"opioidFullYear":30581,"opioidRatio":0.07100364983293188,"oxycodoneOtherRatio":0.003584162448292025,"opioidFullYearRatio":0.00921224338806677},{"region":"VLAAMS GEWEST","year":"2016","mcMembers":3325809,"opioid":246004,"oxycodoneOther":12802,"opioidFullYear":32146,"opioidRatio":0.07396816834640835,"oxycodoneOtherRatio":0.003849289000059835,"opioidFullYearRatio":0.009665618199962776},{"region":"VLAAMS GEWEST","year":"2017","mcMembers":3327966,"opioid":251437,"oxycodoneOther":13600,"opioidFullYear":null,"opioidRatio":0.07555275504617535,"oxycodoneOtherRatio":0.004086580211456487,"opioidFullYearRatio":null},{"region":"VLAAMS GEWEST","year":"2018","mcMembers":3332897,"opioid":259612,"oxycodoneOther":14230,"opioidFullYear":33662,"opioidRatio":0.0778937962979354,"oxycodoneOtherRatio":0.00426955888525808,"opioidFullYearRatio":0.010099922079800245}]];

export default class TinyConsumptionEvolution extends Chart {
  create() {
    this.svg = super.createRoot();

    this.axis = this.svg.append('g')
      .attr('class', 'axis');

    this.xAxis = this.axis.append("g")
      .attr("transform", `translate(0,${this.props.height})`)
      .attr("class", "axis xAxis")

    this.yAxis = this.axis.append("g")
      .attr("class", "axis yAxis")

    this.yAxisLabel = this.axis.append('text')
      .attr("class", "yAxisLabel")
      .attr("text-anchor", "start")
      .attr("x", 3)
      .attr("y", 5);

    this.main = this.svg.append('g')
      .attr('class', 'main');

    this.path = this.main.append("g")
      .attr("class", "evolution")
  }

  // Main D3 rendering, that should be redone when the data updates.
  update(state) {
    if (JSON.stringify(state) !== JSON.stringify(this.state)) {
      this.drawChart(state);
    }
  }

  drawChart(state) {
    const data = [
      {
        label: 'Wallonie',
        color: 'dodgerblue',
        data: consumptionEvolutionData[1]
          .map(d => ({ x: d.year , y: d.opioidRatio * 100}))
          .sort((a,b) => a.x < b.x)
      },
      {
        label: 'Bruxelles',
        color: '#FFB300',
        data: consumptionEvolutionData[0]
          .map(d => ({ x: d.year , y: d.opioidRatio * 100}))
          .sort((a,b) => a.x < b.x)
      },
      {
        label: 'Flandre',
        color: '#E91E63',
        data: consumptionEvolutionData[2]
          .map(d => ({ x: d.year , y: d.opioidRatio * 100}))
          .sort((a,b) => a.x < b.x)
      }
    ]

    const maxY = d3.max(data[0].data.concat(data[1].data).concat(data[2].data), v => v.y)
    const extentY = [0, maxY];
    const extentX = d3.extent(data[0].data, v => v.x)
    
    const y = d3.scaleLinear()
      .domain(extentY)
      .range([this.props.height, 0])
      .nice();

    const x = d3.scaleLinear()
      .domain(extentX)
      .range([0, this.props.width])

    const xAxis = d3.axisBottom(x)
      .ticks(null, "d")
      .tickSizeOuter(0)
    
    this.xAxis.call(xAxis);
    this.yAxis
      .call(d3.axisRight(y)
          .tickSize(this.props.width)
          .ticks(5)
          .tickFormat(d => `${d}%`))
      .call(g => g.select(".domain")
          .remove())
      .call(g => g.selectAll(".tick:not(:first-of-type) line")
          .attr("stroke-opacity", 0.3)
          .attr("stroke-dasharray", "2,2"))
      .call(g => g.selectAll(".tick text")
          .attr("x", 4)
          .attr("dy", -4))

    const line = d3.line()
      .curve(d3.curveNatural)
      .x(d => x(d.x))
      .y(d => y(d.y));

    const paths = this.path.selectAll('path')
      .data(data) 

    paths.enter()
      .append('path')
      .attr("fill", "none")
      .attr("stroke", d => d.color)
      .attr("stroke-width", 3)
      .attr("d", d => line(d.data))
  }
}





// WEBPACK FOOTER //
// ./src/components/charts/TinyConsumptionEvolution/TinyConsumptionEvolution.js